import React, {useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setGroheSimilarProductsOpened, setGroheSimilarFeature} from "../../../../actions/groheFunctions";
import {getDisplaySameColorGroups, getSameColorFeatures} from "../../lookNavigation/lookFunctions";
import GroheFeatureShort from "./groheFeature/groheFeatureShort";
//import GroheFeatureShortWizard from "./groheFeature/groheFeatureShortWizard";
//import {getAvailableWizardList} from "./groheFunctions";
import {getFeatureGroupName} from "../../../../misc/helpers";
import LookFeatureImage from "../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import LookCanvasContext from "../../lookCanvasContext";
import WithChangeFeature from "../../hocs/withChangeFeature";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const GroheSimilarProducts = (props) => {
  const {intl, similarProductsOpened, setGroheSimilarProductsOpened, similarFeature, filterGroups, moreInfoOpened,
    lookActiveCategory, lookPageOpened, fabricatorData, isMobile, setGroheSimilarFeature, lookActiveFeature} = props;

  useEffect(()=> {
    if((moreInfoOpened || lookActiveCategory || lookPageOpened ) && similarProductsOpened) {
      setGroheSimilarProductsOpened(false);
      setGroheSimilarFeature(null);
    }
  });

  const closeButtonClick = (zoomToFeatureGroup) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSimilarListClose);
    setGroheSimilarProductsOpened(!similarProductsOpened);
    if (lookActiveFeature) {
      zoomToFeatureGroup(lookActiveFeature.partId, lookActiveFeature, null, false);
    }
  };

  const {sameColorFeatures, differentColorFeatures} = getSameColorFeatures(similarFeature, filterGroups, false);
  const displaySameColorGroups = getDisplaySameColorGroups(
    similarFeature, [...sameColorFeatures, ...differentColorFeatures], filterGroups
  );
  //const qtCatProperties = getAvailableWizardList(lookActiveFeature);
  const featureGroup = similarFeature ? similarFeature.getParent() : null;
  const featureGroupName = featureGroup ? getFeatureGroupName(featureGroup, intl, fabricatorData) : null;

  const groheSimilarItemClick = (changeFeature, zoomToFeatureGroupByFeature) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSimilarListTitle);
    changeFeature(similarFeature);
    zoomToFeatureGroupByFeature(similarFeature)
  };

  //console.log("qtCatProperties", qtCatProperties);
  return (
    <LookCanvasContext.Consumer>
    {(imageCanvas) => (
      <section className={"grohe-similar " + (similarProductsOpened && displaySameColorGroups.length ? " grohe-similar--opened" : "")}>
        <header className="grohe-similar__header">
          <div className="lk-title">
            <h2 className="lk-title__text">
              <FormattedMessage id={"grohe.feature.similarProducts"}/>
            </h2>
            <WithZoomToFeature imageCanvas={imageCanvas}>
              {(zoomToFeatureGroup) => (
                <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                            className="look-icon look-icon--small"
                            classes={{}}
                            onClick={() => closeButtonClick(zoomToFeatureGroup)}>
                  <CloseIcon/>
                </IconButton>
              )}
            </WithZoomToFeature>
          </div>
          {isMobile ? null : (
            <WithZoomToFeature imageCanvas={imageCanvas}>
              {(zoomToFeatureGroup, zoomToFeatureGroupByFeature) => (
                <WithChangeFeature>
                  {(changeFeature) => (
                    <div className="grohe-card" onClick={() => groheSimilarItemClick(changeFeature, zoomToFeatureGroupByFeature)}>
                      <div className="lk-image">
                        {similarFeature ? <LookFeatureImage forFeature={similarFeature} withoutGallery={true}/> : null}
                      </div>
                      <div className="lk-descriprion">
                        <FormattedMessage id={"grohe.feature.similarProductsDescriptionPart1"}/>
                        {featureGroupName}
                        <FormattedMessage id={"grohe.feature.similarProductsDescriptionPart2"}/>
                      </div>
                    </div>
                  )}
                </WithChangeFeature>
              )}
            </WithZoomToFeature>
          )}
        </header>
        <div className="lk-feature__small">
          {displaySameColorGroups.map(sameColorObject => (
            <div className="grohe-same__list-section" key={sameColorObject.colName}>
              <h4 className="grohe-same__list-section-title">
                <FormattedMessage id={`grohe.sameColor.section.${sameColorObject.colName === "other" ? "other" : "title"}`}
                                  values={{collectionName: sameColorObject.colName}}/>
              </h4>
              {sameColorObject.features.map(feature => {
                return <GroheFeatureShort intl={intl} fabricatorData={fabricatorData} feature={feature} key={feature.dbFeature.id}/>
              })}
            </div>
          ))}
          {/*{Object.values(qtCatProperties).map((qtCatProperty, index) => {*/}
          {/*  return (*/}
          {/*    <GroheFeatureShortWizard key={index} qtCatProperty={qtCatProperty}/>*/}
          {/*  )*/}
          {/*})}*/}
        </div>
      </section>
    )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {moreInfoOpened, lookActiveCategory, lookActiveFeature, lookPageOpened} = store.lookState;
  const {similarFeature, similarProductsOpened} = store.groheState;
  const {filterGroups} = store.filterState;
  const {isMobile} = store.serverState;
  return {
    similarProductsOpened,
    similarFeature,
    fabricatorData: store.fabricatorState,
    filterGroups,
    moreInfoOpened,
    lookActiveCategory,
    lookPageOpened,
    isMobile,
    lookActiveFeature,
  };
};

const mapDispatchToProps = {
  setGroheSimilarProductsOpened,
  setGroheSimilarFeature
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheSimilarProducts)
);
